module.exports = __webpack_public_path__ + "static/img/youhui.75ecdfb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/youhui.svg
// module id = AyzU
// module chunks = 66